export type CityVerdict = "approve" | "reject" | "needs_change" | null;

export interface CityReportStation {
  id: string;
  label: string;
  role: "main" | "backup";
  lat: number;
  lng: number;
  city_verdict: CityVerdict;
  admin_tier: number | null;
  conditions: {
    public_access: boolean | null;
    open_24_7: boolean | null;
    opening_hours: string | null;
    passing_by_visibility: boolean | null;
    nearby_habitations: boolean | null;
    lighting_present: boolean | null;
  };
  address: string | null;
  photos: Array<{ id: string; url: string; captured_at: string | null }>;
  lockers: Array<{ locker_index: number; sport_type: string | null }>;
  comment_count: number;
}

export interface CityReportCollection {
  id: string;
  title: string;
  client_name: string | null;
  intro: string | null;
  logo_url: string | null;
  hub_size: number | null;
  closed: boolean;
}

export const VERDICT_COLORS: Record<Exclude<CityVerdict, null> | "none", string> = {
  approve: "#22c55e",
  reject: "#ef4444",
  needs_change: "#f59e0b",
  none: "#9ca3af",
};

export function verdictColor(v: CityVerdict): string {
  return v ? VERDICT_COLORS[v] : VERDICT_COLORS.none;
}

export function verdictLabel(v: CityVerdict): string {
  switch (v) {
    case "approve":
      return "Approved";
    case "reject":
      return "Rejected";
    case "needs_change":
      return "Needs change";
    default:
      return "Not reviewed";
  }
}
